export enum CHART_TYPE {
  SINGLE_AXIS = 1,
  CROSS_AXIS = 2,
}

export enum CHART_FIELD {
  FEEDBACK_ALL = 1,
  FEEDBACK_AGENT,
  FEEDBACK_CATEGORY,
  FEEDBACK_CES_SCORE,
  FEEDBACK_CSAT,
  FEEDBACK_DATA_ORIGIN,
  FEEDBACK_NPS_SCORE,
  FEEDBACK_REMARKS,
  FEEDBACK_RATING_SCORE,
  FEEDBACK_SENTIMENT,
  FEEDBACK_SOURCE,
  FEEDBACK_TAG,

  ACCOUNT_ACTIVE_STATUS,
  ACCOUNT_AGENT,
  ACCOUNT_COUNTRY,
  ACCOUNT_INDUSTRY,
  ACCOUNT_NAME,
  ACCOUNT_USECASE,
  ACCOUNT_PLAN,
  ACCOUNT_RATING,
  ACCOUNT_SIZE,
  ACCOUNT_STAGE,
  ACCOUNT_TYPE,

  CONTACT_AGENT,
  CONTACT_COUNTRY,
  CONTACT_NAME,
  CONTACT_PLAN,
  CONTACT_STAGE,
  CONTACT_TYPE,

  TAXONOMY_TOPIC,
  FEEDBACK_SENTIMENT_DETAIL,

  PRODUCT_BRAND,
  PRODUCT_LINE,
  PRODUCT_PRODUCT,
  PRODUCT_PRODUCT_OPTION,

  DEMOGRAPHIC_LOCATION,
  DEMOGRAPHIC_AGE,
  DEMOGRAPHIC_GENDER,
  DEMOGRAPHIC_RACE,

  FEEDBACK_LANGUAGE,
  FEEDBACK_AD_PREDICTION,
  FEEDBACK_HASHTAG,
  FEEDBACK_MENTION,
  FEEDBACK_KEYWORD,

  QUERY,
}

export const ENTIRE_ONLY_FIELDS = new Set<CHART_FIELD>([
  CHART_FIELD.FEEDBACK_ALL,
  CHART_FIELD.FEEDBACK_HASHTAG,
  CHART_FIELD.FEEDBACK_KEYWORD,
  CHART_FIELD.FEEDBACK_MENTION,
]);

export enum CHART_GRAPH {
  AREA = 1,
  AREA_STACKED,
  BAR,
  BAR_STACKED,
  LINE,
  PIE,
  TABLE,
  COMBO_CHART,
  WORD_CLOUD,
}

export enum CHART_WORD_CLOUD_BASIS {
  KEYWORD = 'keywords',
  HASHTAG = 'hashtags',
}

export enum CHART_FREQUENCY {
  DAY = 1,
  WEEK,
  MONTH,
  HOUR,
}

export enum CHART_FIELD_ITEM_SELECTION_METHOD {
  USER_DEFINED = 1,
  TOP_5,
  TOP_10,
  TOP_20,
  TOP_30,
  TOP_40,
  TOP_50,
  TOP_100,
}

export enum CHART_TERM_TYPE {
  PERIODIC = 1,
  FIXED,
}

export enum CHART_PERIOD_RELATIVE {
  INCLUDE = 1,
  EXCLUDE,
}

export enum CHART_TERM_UNIT {
  DAY = 1,
  WEEK,
  MONTH,
  QUARTER,
  HOUR,
}

export enum CHART_METRIC {
  UNIQUE_ACCOUNT = 1,
  ACCOUNT_REVENUE_IMPACT = 2,
  UNIQUE_CONTACT = 3,
  CONTACT_REVENUE_IMPACT = 4,
  FEEDBACK = 5,
  CES_SCORE = 6,
  NPS_SCORE = 7,
  CSAT_SCORE = 8,
  RATING_SCORE = 9,
  TOTAL_ENGAGEMENT = 10,
  ENGAGEMENT_RATE = 11,
  IMPRESSION = 12,
}

export enum CHART_CALCULATION {
  COUNT = 1,
  SUM,
  AVERAGE,
}

export enum CHART_METRIC_VIEW_TYPE {
  COUNT = 1,
  PERCENTAGE,
}

export enum CHART_COLOR_SCALE {
  WHITE_TO_GREEN = 1,
  GREEN_TO_WHITE,
  WHITE_TO_RED,
  RED_TO_WHITE,
  GREEN_TO_RED,
  RED_TO_GREEN,
}

export enum CHART_COMPARE_TERM_TYPE {
  PREVIOUS = 1,
  YEAR_BEFORE,
  FIXED,
}

export enum CHART_GRAPH_DIRECTION {
  VERTICAL = 1,
  HORIZONTAL,
}

export enum CHART_METRIC_TYPE {
  COUNT = 1,
  SCORE,
}

export enum CHART_SHARE_CALCULATION_TYPE {
  GRAND_TOTAL = 1,
  ROW,
  COLUMN,
  CELL,
}

export enum CHART_TOOLTIP_TARGET_TYPE {
  CURRENT = 'CURRENT',
  COMPARE = 'COMPARE',
}

export const ChartGraphListByChartType = {
  [CHART_TYPE.SINGLE_AXIS]: [
    CHART_GRAPH.BAR,
    CHART_GRAPH.PIE,
    CHART_GRAPH.LINE,
    CHART_GRAPH.BAR_STACKED,
    CHART_GRAPH.TABLE,
    CHART_GRAPH.AREA_STACKED,
    CHART_GRAPH.COMBO_CHART,
    CHART_GRAPH.WORD_CLOUD,
  ],
  [CHART_TYPE.CROSS_AXIS]: [CHART_GRAPH.BAR_STACKED, CHART_GRAPH.TABLE],
};

export const CHART_SOURCE_SEPERATOR = '+';
export const CHART_X_TOTAL_KEY = 'x-total';
export const CHART_TOTAL_ROW_KEY = 'y-total';
export const CHART_ROW_TOTAL_COLUMN_KEY = 'row-total';
export const CHART_X_FIELD_NAME = 'x-field-name';
export const CHART_ALL_FEEDBACK_ALIAS = 'all';
